<template>
  <vs-card>
    <div class="vx-row pt-5 px-5">
      <div class="vx-col w-full px-8">
        <form method="POST" @submit.prevent="">
          <!-- Chips Section -->
          <div class="vx-row pt-5 px-5">
            <div class="vx-col w-full">
              <p class="note-text mb-2 text-lg"><strong>Note:</strong> Simply press Enter to add a keyword. All keywords must be in lowercase letters.</p>
              <vs-chips color="rgb(145, 32, 159)" placeholder="Add Restricted Keywords" v-model="chips" @input="handleChipInput" :remove-icon="chips.length > 0 ? 'close' : ''">
                <vs-chip :key="chip" @click="remove(chip)" v-for="chip in chips" closable>
                  {{ chip }}
                </vs-chip>
              </vs-chips>
            </div>
          </div>

          <!-- Save & Reset Button -->
          <div class="vx-row pt-5 px-5 text-center">
            <div class="vx-col w-full">
              <div class="items-center">
                <vs-button class="mr-2 vs-con-loading__container" @click="save_changes">
                  {{ 'Update' }}
                </vs-button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </vs-card>
</template>

<script>
import { mapActions, mapState } from 'vuex'
export default {
  name: 'restrictedKeyword',

  /** data */
  data() {
    return {
      chips: [] // Array to store chips
    }
  },

  /** computed */
  computed: {
    ...mapState('restrictedKeyword', ['createLoading']),
    validateForm() {
      return !this.errors.any()
    }
  },

  /** created */
  async created() {
    await this.$store.dispatch('restrictedKeyword/show').then(async (res) => {
      this.chips = res.data.data.keywords || []
    })
  },

  /** methods */
  methods: {
    ...mapActions('restrictedKeyword', {
      update: 'update'
    }),

    // Method to handle chip removal
    remove(item) {
      this.chips.splice(this.chips.indexOf(item), 1)
    },

    // Method to handle chip input and prevent empty strings
    handleChipInput() {
      // Filter out empty strings
      this.chips = this.chips.filter((chip) => chip.trim() !== '')
    },

    async save_changes() {
      if (!(await this.$validator.validate())) {
        this.$vs.notify({
          title: 'Error',
          text: 'Please fix the error first',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          position: 'top-center',
          time: 5000,
          color: 'primary'
        })
        return false
      }

      try {
        const response = await this.update({
          data: { new_keywords: this.chips }
        })
        this.$vs.notify({
          title: 'Success',
          text: response.message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          position: 'top-center',
          time: 5000,
          color: 'success'
        })
      } catch ({ message }) {
        this.$vs.notify({
          title: 'Error',
          text: message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          position: 'top-center',
          time: 5000,
          color: 'primary'
        })
      }
    }
  }
}
</script>

<style lang="scss">
.text-chip {
  color: black;
}
.con-chips {
  gap: 10px;
  padding: 10px;
}
.con-chips {
  padding-right: 50px;
}
/* Optional: You can add some custom styling for the chips here */
</style>
